(function () {
    var $cards = $('.js-newsletter-card');
    var $dropdown = $("#newsletter-dropdown");
    var $dropdownBtn = $("#newsletter-year-dd");
    var $checkboxes = $('.js-newsletter-year');
    var yearsSelected;

    $dropdown.slideUp();

    // open close dropdown
    $dropdownBtn.on("click", function(){
        $dropdown.slideToggle();
    })

    $dropdown.mouseenter(function(){
        $dropdown.mouseleave(function(){
            setTimeout(function(){
                $dropdown.slideUp();
            }, 1000)
        })
    })

    // close on blur
    $(window).on("click", function(e){
        var $target = $(e.target)
        if ($target.parents('.c-dropdown').length) {
            return;
        }
        if ($target.hasClass("c-dropdown")){
            return;
        }
        $dropdown.slideUp();
    })
    
    // handle filter
    $checkboxes.on("change", function(e){
        var $checkbox = $(e.target);
        var checkBoxYear = $checkbox.val();

        $cards.each(function(i, card){
            if ($(card).attr('data-year').indexOf(checkBoxYear) != -1){
                if ($checkbox.is(":checked")){
                    $(card).show();
                } else {
                    $(card).hide();
                }
            }
        })

        var currentYears = "";
        $checkboxes.each(function(i, checkbox){
            if ($(checkbox).is(":checked")){
                currentYears += checkbox.value + ", ";
            }
        })
        currentYears = currentYears.slice(0, currentYears.length - 2);
        $dropdownBtn.text(currentYears)

        if ($('.js-newsletter-year:checked').length == 1) {
            $('.js-newsletter-year:checked').attr("disabled", true);
        } else {
            $('.js-newsletter-year').attr("disabled", false);
        }
    })

    // init
    $cards.each(function(i, card){
        var startYear = $checkboxes[0].value
        if ($(card).attr('data-year').indexOf(startYear) != -1) {
            $(card).show();
        } else {
            $(card).hide();
        }
    })

})();
